import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

interface PermissionGuardProps {
  children: React.ReactNode;
  module: string;
  action?: string;
  requireAll?: boolean;
  fallback?: React.ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  module,
  action,
  requireAll = false,
  fallback = null,
}) => {
  const { hasPermission, hasAnyPermission, getModulePermissions } = usePermissions();

  // If specific action is required
  if (action) {
    const hasRequiredPermission = hasPermission(module, action);
    return hasRequiredPermission ? <>{children}</> : <>{fallback}</>;
  }

  // If any permission is sufficient
  if (!requireAll) {
    const hasAnyModulePermission = hasAnyPermission(module);
    return hasAnyModulePermission ? <>{children}</> : <>{fallback}</>;
  }

  // If all permissions are required (rarely used)
  const permissions = getModulePermissions(module);
  const hasAllPermissions = permissions.canCreate && 
                           permissions.canRead && 
                           permissions.canUpdate && 
                           permissions.canDelete;

  return hasAllPermissions ? <>{children}</> : <>{fallback}</>;
};

export default PermissionGuard;